import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { AccommodationsDataService } from '../../accommodations-data.service';
import { AccommodationsService } from '../../accommodations.service';

interface DialogData {
	data: [];
}

@Component({
	selector: 'app-accommodations-reservations-dok',
	templateUrl: './accommodations-reservations-dok.component.html',
	styleUrls: ['./accommodations-reservations-dok.component.scss'],
})
export class AccommodationsReservationsDokComponent implements OnInit {
	protected reservations = [];
	protected state = null;

	constructor(
		private readonly loader: LoaderService,
		private readonly erp: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly dataService: AccommodationsDataService,
		protected service: AccommodationsService,
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
	) {}

	ngOnInit(): void {
		this.state = this.data[0];
		this.reservations = this.data[1];
	}

	doc(reservation) {
		this.loader.show('doc');
		this.erp.command(
			`/Bag/BagIstourAccomodation/`,
			{
				cmd: 'dok',
				state: this.state,
				capacitie: reservation.businessCasesCapacities,
			},
			(result, error) => {
				if (error) {
					return;
				}
				if (!result.data) {
					return this.infobox.error(
						'Przykro mi ale miałem mało czasu... wykwateruj tą rezerwacje do kórej chciałeś dokwaterować. Zakwateruj najdłuższą a później dokwaterowuj pozostałe',
					);
				} else {
					this.infobox.success('Supcio udało się');
				}
				this.dataService.loadReservationWithOutRoom();
				this.service.accommodateCapaciteAfterDok(result.data.data);
				this.loader.hide('doc');
			},
		);
	}
}
